#import "../fragments/sms-drip-edition-fragment.graphql"

mutation UpdateSmsDripEdition($edition: SmsEditionUpdateInput!) {
    smsEditionUpdate(input: $edition) {
        edition {
            ...SmsDripEditionFragment
        }
    }
}
